import { render, staticRenderFns } from "./accountManage.vue?vue&type=template&id=8a2a1320&"
import script from "./accountManage.vue?vue&type=script&lang=js&"
export * from "./accountManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports